import { render } from "./ThirdStage.vue?vue&type=template&id=580c07fe&scoped=true"
import script from "./ThirdStage.vue?vue&type=script&lang=js"
export * from "./ThirdStage.vue?vue&type=script&lang=js"

import "./ThirdStage.vue?vue&type=style&index=0&id=580c07fe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580c07fe"]])

export default __exports__